/**
 * @generated SignedSource<<f3df3e64707170a732de7854b3c3ec3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeeUpdateInput = {
  externalRef?: string | null;
  accountId?: string | null;
  name?: string | null;
  description?: string | null;
  amount?: number | null;
  currencyCode?: string | null;
  meta?: any | null;
  createdBy?: string | null;
  type?: string | null;
};
export type feeUpdateMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  input: FeeUpdateInput;
};
export type feeUpdateMutation$data = {
  readonly updateFee: {
    readonly fee: {
      readonly " $fragmentSpreads": FragmentRefs<"feeInlineFragment">;
    };
  };
};
export type feeUpdateMutation = {
  variables: feeUpdateMutation$variables;
  response: feeUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createdBy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currencyCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "externalRef",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "feeUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FeePayload",
        "kind": "LinkedField",
        "name": "updateFee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Fee",
            "kind": "LinkedField",
            "name": "fee",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "feeInlineFragment",
                "selections": (v2/*: any*/)
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "feeUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FeePayload",
        "kind": "LinkedField",
        "name": "updateFee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Fee",
            "kind": "LinkedField",
            "name": "fee",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "fee",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "Edge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b01d39c40c6549ddc25fa3c6cb2313d",
    "id": null,
    "metadata": {},
    "name": "feeUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation feeUpdateMutation(\n  $id: ID!\n  $input: FeeUpdateInput!\n) {\n  updateFee(id: $id, input: $input) {\n    fee {\n      ...feeInlineFragment\n      id\n    }\n  }\n}\n\nfragment feeInlineFragment on Fee {\n  id\n  name\n  amount\n  createdAt\n  createdBy\n  currencyCode\n  description\n  externalRef\n  type\n}\n"
  }
};
})();

(node as any).hash = "6e5558b56c80da7c775adcaeff9f520b";

export default node;
